{
  "legalConfirmLabel": "Close",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "Privacy Policy",
  "legalTermsOfUse": "Terms of Use",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms",
  "profileLegalNoticesMenuItem": "Legal notices"
}
